export default __webpack_public_path__ + "static/media/female_pancreas-01.6fa27b72.png";